/* eslint-disable no-unused-vars */
import { Container } from 'react-bootstrap';
import ArticleDetail from '../../../Components/articleDetail/ArticleDetail';
import heartBurn from '../../../assets/images/png/heartburn.png';
import docImg from '../../../assets/images/png/review_by.png';
import NewsLetter from '../../../Components/newsletter/NewsLetter';
import GerdSymtoms from '../gerdSymtoms/GerdSymtoms';
import GerdTreatments from '../gerdTreatments/GerdTreatments';
import Resource from '../../../Components/resource/Resource';
import ArticleFooter from '../../../Components/articleFooter/ArticleFooter';
import BulletLinkList from '../../../Components/bulletLinkList/BulletLinkList';
import './acidRefluxAndGerd.css';

const sourcePoints = [
  {
    text: 'Acid reflux. (n.d.).',
    link: 'gi.org/topics/acid-reflux/'
  },
  {
    text: 'Antacids. (2019).',
    link: 'nhs.uk/conditions/antacids/'
  },
  {
    text: 'Clarrett D, et al. (2018). Gastroesophogeal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC6140167/'
  },
  {
    text: 'Disposal of unused medicines: What you should know. (2020). ',
    link: 'fda.gov/drugs/safe-disposal-medicines/disposal-unused-medicines-what-you-should-know '
  },
  {
    text: 'Eating, diet, & nutrition for GER & GERD. (2020). ',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/eating-diet-nutrition'
  },
  {
    text: 'Food and Drug Administration. (2020). FDA requests removal of all ranitidine products (Zantac) from the market [Press release]. ',
    link: 'fda.gov/news-events/press-announcements/fda-requests-removal-all-ranitidine-products-zantac-market '
  },
  {
    text: 'Heart attack symptom, risk, and recovery. (2021).',
    link: 'cdc.gov/heartdisease/heart_attack.htm'
  },
  {
    text: 'Heartburn. (2016).',
    link: 'medlineplus.gov/heartburn.html'
  },
  {
    text: 'Heartburn. (2017).',
    link: 'familydoctor.org/condition/heartburn'
  },
  {
    text: 'Martinucci I, et al. (2014). Esophageal motility abnormalities in gastroesophageal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4023328/'
  },
  {
    text: 'Over-the-counter heartburn treatment. (2021).',
    link: 'fda.gov/drugs/information-consumers-and-patients-drugs/over-counter-otc-heartburn-treatment'
  },
  {
    text: 'Richter JE, et al. (2019). Presentation and epidemiology of gastroesophageal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC5797499/'
  },
  {
    text: 'Symptoms and causes of GERD. (2020).',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/symptoms-causes'
  },
  {
    text: 'Treatment for GER and GERD. (2020).',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/treatment'
  },
  {
    text: 'Vasquez J. (2015). Heartburn in pregnancy.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4562453/'
  }
];

const tags = [
  { text: 'Symptoms', link: '/' },
  { text: 'Treatment Options', link: '/' },
  { text: 'Home Remedies', link: '/' },
  { text: 'Diagnosing GERD', link: '/' },
  { text: 'GERD Vs. Heartburn', link: '/' },
  { text: 'Causes', link: '/' },
  { text: 'Dietary Triggers', link: '/' },
  { text: 'GERD And Other Conditions', link: '/' },
  { text: 'GERD In Infants', link: '/' },
  { text: 'Potential Complications', link: '/' },
  { text: 'Takeaway', link: '/' }
];

function AcidRefluxAndGerd() {
  return (
    <section>
      <Container>
        <ArticleDetail
          articleReviewImage={docImg}
          articleReviewByName="Medically reviewed by Youssef (Joe) Soliman, MD"
          articleWrittenByName="Written by Jessica DiGiacinto"
          articleUpdateOn="Updated on October 20, 2021"
          articleTitle="Everything You Need to Know About Acid Reflux and GERD"
          articleImg={heartBurn}
          tagData={tags?.map(({ text, link }) => ({
            tagText: text,
            tagLink: link
          }))}
          articleDesc="Acid reflux happens when contents from your stomach move back up into your esophagus. This action is also called acid regurgitation or gastroesophageal reflux. If you have symptoms of acid reflux more than twice a week, you might have a condition known as gastroesophageal reflux disease (GERD). According to the National Institute of Diabetes and Digestive and Kidney Diseases (NIDDK)Trusted Source, GERD affects about 20 percent of people in the United States. If left untreated, it can sometimes cause serious complications."
        />
        <NewsLetter />
        <GerdSymtoms />
        <GerdTreatments />
        <Resource />
        <ArticleFooter
          sourceReviewDate="Last medically reviewed on October 20, 2021"
          sourceHeading="18 sources"
          sourceDesc="Healthline has strict sourcing guidelines and relies on peer-reviewed studies, academic research institutions, and medical associations. We avoid using tertiary references. You can learn more about how we ensure our content is accurate and current by reading our editorial policy."
          sourceContent={[
            <BulletLinkList
              points={sourcePoints.map(({ link, text }) => ({
                pointText: text,
                pointLink: link,
                pointlinkText: link
              }))}
            />
          ]}
        />
      </Container>
    </section>
  );
}

export default AcidRefluxAndGerd;
